import { useEffect, useState } from "react";
import { MixLineChart } from "../../common/components/Chart/MixLineChart";
import { PieChart } from "../../common/components/Chart/PieChart";
import { TargetGlobal } from "./components/TargetGlobal";
import { DashboardService } from "./core/_request";
import FeatureOperation from "./components/FeatureOperation";
import { Loader } from "../../common/components/Loader/Loader";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";

const Dashboard = () => {
  const [numberOperations, setNumberOperations] = useState<any | null>(null);
  const [operationDistribution, setOperationDistribution] = useState<
    any | null
  >(null);
  const [operationalSummary, setOperationalSummary] = useState<any | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedYearDistribution, setSelectedYearDistribution] = useState(
    new Date().getFullYear()
  );

  useEffect(() => {
    fetchAll();
  }, []);

  useEffect(() => {
    fetchNumberOperations(selectedYear);
  }, [selectedYear]);

  useEffect(() => {
    fetchOperationDistribution(selectedYearDistribution);
  }, [selectedYearDistribution]);

  const fetchAll = async () => {
    setIsLoading(true);
    try {
      await Promise.all([
        fetchNumberOperations(selectedYear),
        fetchOperationDistribution(),
        fetchOperationalSummary(),
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchNumberOperations = async (year?: number) => {
    try {
      const data = await DashboardService.getNumberOperations(year);
      if (data) {
        setNumberOperations(data);
      }
    } catch (error) {
      console.error("Error fetching number of operations:", error);
    }
  };

  const fetchOperationDistribution = async (year?: number) => {
    try {
      const data = await DashboardService.getOperationDistribution(year);
      if (data) {
        setOperationDistribution(data);
      }
    } catch (error) {
      console.error("Error fetching operation distribution:", error);
    }
  };

  const fetchOperationalSummary = async () => {
    try {
      const data = await DashboardService.getOperationalSummary();
      if (data) {
        setOperationalSummary(data);
      }
    } catch (error) {
      console.error("Error fetching operational summary:", error);
    }
  };

  return (
    <div className="dashboard">
      <Loader isLoading={isLoading} />
      <TitleHeader title="Tableau de bord" />
      {/* <div className="dashboard-header">Tableau de bord</div> */}
      <div className="mb-5 mt-2">
        <TargetGlobal data={operationalSummary} />
      </div>
      <div
        className="d-flex mt-5"
        style={{
          gap: "24px",
          maxWidth: "100%",
          overflowX: "auto",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            flex: "1 1 70%",
            minWidth: "300px",
            backgroundColor: "#fff",
            padding: "16px",
            borderRadius: "8px",
          }}
        >
          <div className="d-flex align-items-center justify-content-between mb-3">
            <p style={{ color: "#677788", marginBottom: 0 }}>
              Nombre d'opérations par mois
            </p>
            <DatePicker
              picker="year"
              value={dayjs(String(selectedYear), "YYYY")}
              onChange={(_, dateString) => {
                if (dateString) {
                  setSelectedYear(Number(dateString));
                }
              }}
              allowClear={false}
            />
          </div>
          <MixLineChart data={numberOperations} />
        </div>

        <div
          style={{
            flex: "1 1 28%",
            minWidth: "300px",
            backgroundColor: "#fff",
            padding: "16px",
            borderRadius: "8px",
          }}
        >
          <div className="d-flex align-items-center justify-content-between mb-3">
            <p style={{ color: "#677788", marginBottom: 0 }}>
              Répartition des opérations
            </p>
            <DatePicker
              picker="year"
              value={dayjs(String(selectedYearDistribution), "YYYY")}
              onChange={(_, dateString) => {
                if (dateString) {
                  setSelectedYearDistribution(Number(dateString));
                }
              }}
              allowClear={false}
            />
          </div>
          <PieChart data={operationDistribution?.value} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #0FDA6B",
              borderRadius: "12px",
              background: "#0FDA6B96",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              width: "50%",
              margin: " auto",
            }}
          >
            <p style={{ marginBottom: 0, padding: "8px 0" }}>
              Nombre total : {operationDistribution?.total}
            </p>
          </div>
        </div>
      </div>
      <div
        className="mt-5"
        style={{
          flex: 3,
          minWidth: 0,
          backgroundColor: "#fff",
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <FeatureOperation />
      </div>
    </div>
  );
};

export default Dashboard;
